import React, { useState } from 'react';
import useReveal from '../hooks/useReveal';
import Modal from './Modal';
import photo1 from '../assets/images/DSC04252.JPG';
import photo2 from '../assets/images/DSC04167.JPG';
import photo3 from '../assets/images/DSC04292.JPG';
import photo4 from '../assets/images/DSC04307.JPG';
import photo5 from '../assets/images/DSC05383.JPG';
import photoHotel from '../assets/images/pet-hotel.JPG';
import photoShop from '../assets/images/pet-shop.JPG';
import photoGrooming from '../assets/images/pet-grooming.JPG';

const PHOTOS = [
  { src: photo1, alt: 'การดูแลลูกแมวอย่างใกล้ชิด' },
  { src: photo2, alt: 'ทีมสัตวแพทย์ขณะตรวจรักษา' },
  { src: photo3, alt: 'บรรยากาศภายในโรงพยาบาล' },
  { src: photoGrooming, alt: 'บริการอาบน้ำ-ตัดขน' },
  { src: photo4, alt: 'การตรวจสุขภาพสัตว์เลี้ยง' },
  { src: photoHotel, alt: 'โรงแรมสัตว์เลี้ยง' },
  { src: photo5, alt: 'ทีมงานของเรา' },
  { src: photoShop, alt: 'ร้านค้าอุปกรณ์สัตว์เลี้ยง' },
];

function Gallery() {
  const sectionRef = useReveal();
  const [selected, setSelected] = useState(null);

  return (
    <section id="gallery" className="reveal" ref={sectionRef}>
      <div className="section-content">
        <span className="section-eyebrow">Gallery</span>
        <h2 className="section-title">บรรยากาศของเรา</h2>
        <p className="section-lead">
          ภาพจริงจากโรงพยาบาลของเรา ทุกมุมออกแบบมาเพื่อความสบายใจของน้องๆ และเจ้าของ
        </p>
        <div className="gallery-grid">
          {PHOTOS.map((photo, index) => (
            <button
              type="button"
              key={photo.alt}
              className={`gallery-item gallery-item-${index + 1}`}
              onClick={() => setSelected(photo)}
              aria-label={`ดูรูป: ${photo.alt}`}
            >
              <img src={photo.src} alt={photo.alt} loading="lazy" />
              <span className="gallery-zoom material-icons" aria-hidden="true">zoom_in</span>
            </button>
          ))}
        </div>
      </div>

      {selected && (
        <Modal onClose={() => setSelected(null)} label={selected.alt} variant="modal-photo">
          <img src={selected.src} alt={selected.alt} />
          <p>{selected.alt}</p>
        </Modal>
      )}
    </section>
  );
}

export default Gallery;
